module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "size": "xl",
      "title": "",
      "hide-footer": "",
      "centered": "",
      "hide-header-close": "",
      "modal-class": "vehicle-premium-modal",
      "body-class": "p-0",
      "header-class": "p-0 border-0"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('update:visible', false)
      }
    },
    model: {
      value: (_vm.localVisible),
      callback: function($$v) {
        _vm.localVisible = $$v
      },
      expression: "localVisible"
    }
  }, [
    [_c('div', {
      staticClass: "dashboard-header w-100 px-4 py-4 d-flex justify-content-between align-items-center"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('div', {
      staticClass: "vehicle-avatar shadow-lg mr-3"
    }, [_c('i', {
      staticClass: "fa fa-truck"
    }), _vm._v(" "), _c('div', {
      staticClass: "status-indicator",
      class: _vm.masterData.truckReachedStatus ? 'active' : 'inactive'
    })]), _vm._v(" "), _c('div', {
      staticClass: "vehicle-identity"
    }, [_c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('h3', {
      staticClass: "mb-0 mr-3 font-weight-bold tracking-tight text-white"
    }, [_vm._v(_vm._s(_vm.vehicleNo))]), _vm._v(" "), (_vm.masterData.vehicletypemaster_relation) ? _c('b-badge', {
      staticClass: "premium-badge px-3 py-1 text-uppercase text-xs",
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v("\n                      " + _vm._s(_vm.masterData.vehicletypemaster_relation.vehicleType) + "\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "d-flex align-items-center mt-1"
    }, [_c('span', {
      staticClass: "text-white-50 text-xs mr-3"
    }, [_c('i', {
      staticClass: "fa fa-barcode mr-1 opacity-50"
    }), _vm._v(" Chassis: "), _c('strong', {
      staticClass: "text-white"
    }, [_vm._v(_vm._s(_vm.masterData.chassisNo || 'N/A'))])]), _vm._v(" "), _c('span', {
      staticClass: "text-white-50 text-xs"
    }, [_c('i', {
      staticClass: "fa fa-cog mr-1 opacity-50"
    }), _vm._v(" Model: "), _c('strong', {
      staticClass: "text-white"
    }, [_vm._v(_vm._s(_vm.masterData.modNo || 'N/A'))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "header-right-actions d-flex align-items-center"
    }, [_c('div', {
      staticClass: "header-stats d-none d-lg-flex mr-4"
    }, [_c('div', {
      staticClass: "stat-group stat-group-clickable",
      on: {
        "click": function($event) {
          _vm.activeTab = 'challan'
        }
      }
    }, [_c('span', {
      staticClass: "stat-label"
    }, [_vm._v("Challans")]), _vm._v(" "), _c('span', {
      staticClass: "stat-value",
      class: _vm.challans.length > 0 ? 'warning' : 'success'
    }, [_vm._v(_vm._s(_vm.challans.length))])]), _vm._v(" "), _c('div', {
      staticClass: "stat-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "stat-group stat-group-clickable",
      on: {
        "click": function($event) {
          _vm.activeTab = 'fasttag'
        }
      }
    }, [_c('span', {
      staticClass: "stat-label"
    }, [_vm._v("Activity")]), _vm._v(" "), _c('span', {
      staticClass: "stat-value info"
    }, [_vm._v(_vm._s(_vm.fasttagData.length))])]), _vm._v(" "), _c('div', {
      staticClass: "stat-divider"
    }), _vm._v(" "), _c('div', {
      staticClass: "stat-group stat-group-clickable",
      on: {
        "click": function($event) {
          _vm.activeTab = 'maintenance'
        }
      }
    }, [_c('span', {
      staticClass: "stat-label"
    }, [_vm._v("Maintenance")]), _vm._v(" "), _c('span', {
      staticClass: "stat-value",
      class: _vm.maintenanceHistory.length > 0 ? 'info' : 'success'
    }, [_vm._v(_vm._s(_vm.maintenanceHistory.length))])])]), _vm._v(" "), _c('button', {
      staticClass: "premium-close-btn",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.localVisible = false
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])])])], _vm._v(" "), (_vm.loading) ? _c('div', {
      staticClass: "loader-container"
    }, [_c('div', {
      staticClass: "premium-loader"
    }), _vm._v(" "), _c('p', {
      staticClass: "mt-4 font-weight-bold text-muted"
    }, [_vm._v("Analyzing Fleet Intelligence...")])]) : (_vm.error) ? _c('div', {
      staticClass: "error-container p-5 text-center"
    }, [_c('div', {
      staticClass: "error-icon mb-3"
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle text-danger fa-3x"
    })]), _vm._v(" "), _c('h5', {
      staticClass: "text-danger"
    }, [_vm._v("Syncing Failed")]), _vm._v(" "), _c('p', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "pill": "",
        "size": "sm"
      },
      on: {
        "click": _vm.fetchDetails
      }
    }, [_vm._v("Retry Synchronization")])], 1) : _c('div', {
      staticClass: "modal-dashboard-layout"
    }, [_c('div', {
      staticClass: "dashboard-sidebar"
    }, _vm._l((_vm.tabs), function(tab) {
      return _c('div', {
        key: tab.id,
        staticClass: "nav-item-premium",
        class: {
          active: _vm.activeTab === tab.id
        },
        on: {
          "click": function($event) {
            _vm.activeTab = tab.id
          }
        }
      }, [_c('i', {
        class: tab.icon
      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(tab.label))]), _vm._v(" "), (tab.count !== undefined) ? _c('b-badge', {
        staticClass: "ml-auto ml-2",
        attrs: {
          "pill": "",
          "variant": "primary"
        }
      }, [_vm._v(_vm._s(tab.count))]) : _vm._e()], 1)
    })), _vm._v(" "), _c('div', {
      staticClass: "dashboard-main-content p-4"
    }, [(_vm.activeTab === 'master') ? _c('div', {
      staticClass: "fade-in"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "glass-card mb-4 p-4 h-100"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium"
    }, [_c('i', {
      staticClass: "fa fa-id-card-o mr-2"
    }), _vm._v(" Identification & Specifications")]), _vm._v(" "), _c('div', {
      staticClass: "row mt-4"
    }, [_c('div', {
      staticClass: "col-sm-6 mb-4"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Registration Number")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium"
    }, [_vm._v(_vm._s(_vm.masterData.regdNo || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 mb-4"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Model No / Year")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium"
    }, [_vm._v(_vm._s(_vm.masterData.modNo) + " / " + _vm._s(_vm.masterData.vmodelYear || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 mb-4"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Chassis Number")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium text-monospace small"
    }, [_vm._v(_vm._s(_vm.masterData.chassisNo || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6 mb-4"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Engine Number")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium text-monospace small"
    }, [_vm._v(_vm._s(_vm.masterData.engineNo || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Last Login / Audit")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium small"
    }, [_vm._v(_vm._s(_vm.formatDateTime(_vm.masterData.loginTime)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-6"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Reach Status")]), _vm._v(" "), _c('b-badge', {
      attrs: {
        "variant": _vm.masterData.truckReachedStatus ? 'success' : 'secondary',
        "pill": ""
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.masterData.truckReachedStatus ? 'Reached' : 'In Transit') + "\n                                ")])], 1)])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('div', {
      staticClass: "glass-card mb-4 compliance-card p-4 h-100"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium"
    }, [_c('i', {
      staticClass: "fa fa-shield mr-2"
    }), _vm._v(" Compliance Track")]), _vm._v(" "), _c('div', {
      staticClass: "compliance-list mt-3"
    }, [_c('div', {
      staticClass: "d-flex flex-wrap mb-3 border-bottom pb-3 opacity-90"
    }, [_c('div', {
      staticClass: "mr-3 mb-2"
    }, [_c('label', {
      staticClass: "text-xs text-muted d-block mb-1"
    }, [_vm._v("Permit")]), _vm._v(" "), _c('b-badge', {
      staticClass: "dot-badge",
      attrs: {
        "variant": _vm.masterData.nPermit == 1 ? 'success' : 'danger',
        "pill": ""
      }
    }, [_vm._v(_vm._s(_vm.masterData.nPermit == 1 ? 'Valid' : 'Invalid'))])], 1), _vm._v(" "), _c('div', {
      staticClass: "mr-3 mb-2"
    }, [_c('label', {
      staticClass: "text-xs text-muted d-block mb-1"
    }, [_vm._v("MV Tax")]), _vm._v(" "), _c('b-badge', {
      staticClass: "dot-badge",
      attrs: {
        "variant": _vm.masterData.mvTax == 1 ? 'success' : 'danger',
        "pill": ""
      }
    }, [_vm._v(_vm._s(_vm.masterData.mvTax == 1 ? 'Paid' : 'Due'))])], 1), _vm._v(" "), _c('div', {
      staticClass: "mr-3 mb-2"
    }, [_c('label', {
      staticClass: "text-xs text-muted d-block mb-1"
    }, [_vm._v("Insurance")]), _vm._v(" "), _c('b-badge', {
      staticClass: "dot-badge",
      attrs: {
        "variant": _vm.masterData.insurValid == 1 ? 'success' : 'danger',
        "pill": ""
      }
    }, [_vm._v(_vm._s(_vm.masterData.insurValid == 1 ? 'Active' : 'Expired'))])], 1), _vm._v(" "), _c('div', {
      staticClass: "mr-3 mb-2"
    }, [_c('label', {
      staticClass: "text-xs text-muted d-block mb-1"
    }, [_vm._v("Fitness")]), _vm._v(" "), _c('b-badge', {
      staticClass: "dot-badge",
      attrs: {
        "variant": _vm.masterData.fitness == 1 ? 'success' : 'danger',
        "pill": ""
      }
    }, [_vm._v(_vm._s(_vm.masterData.fitness == 1 ? 'Fit' : 'Unfit'))])], 1), _vm._v(" "), _c('div', {
      staticClass: "mb-2"
    }, [_c('label', {
      staticClass: "text-xs text-muted d-block mb-1"
    }, [_vm._v("Pollution")]), _vm._v(" "), _c('b-badge', {
      staticClass: "dot-badge",
      attrs: {
        "variant": _vm.masterData.Pollution == 1 ? 'success' : 'danger',
        "pill": ""
      }
    }, [_vm._v(_vm._s(_vm.masterData.Pollution == 1 ? 'Valid' : 'Invalid'))])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "compliance-row"
    }, [_c('span', [_vm._v("Fitness Validity")]), _vm._v(" "), _c('span', {
      staticClass: "date mt-1",
      class: _vm.getDateColorClass(_vm.getComplianceDate('fitness'))
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.getComplianceDate('fitness'))))]), _vm._v(" "), _c('div', {
      staticClass: "progress-simple mt-1",
      class: _vm.getValidityStatus(_vm.getComplianceDate('fitness'))
    })]), _vm._v(" "), _c('div', {
      staticClass: "compliance-row"
    }, [_c('span', [_vm._v("Insurance Validity")]), _vm._v(" "), _c('span', {
      staticClass: "date mt-1",
      class: _vm.getDateColorClass(_vm.getComplianceDate('insurance'))
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.getComplianceDate('insurance'))))]), _vm._v(" "), _c('div', {
      staticClass: "progress-simple mt-1",
      class: _vm.getValidityStatus(_vm.getComplianceDate('insurance'))
    })]), _vm._v(" "), _c('div', {
      staticClass: "compliance-row"
    }, [_c('span', [_vm._v("RC Validity")]), _vm._v(" "), _c('span', {
      staticClass: "date mt-1",
      class: _vm.getDateColorClass(_vm.getComplianceDate('rc'))
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.getComplianceDate('rc'))))]), _vm._v(" "), _c('div', {
      staticClass: "progress-simple mt-1",
      class: _vm.getValidityStatus(_vm.getComplianceDate('rc'))
    })]), _vm._v(" "), _c('div', {
      staticClass: "compliance-row"
    }, [_c('span', [_vm._v("MV Tax Validity")]), _vm._v(" "), _c('span', {
      staticClass: "date mt-1",
      class: _vm.getDateColorClass(_vm.getComplianceDate('tax'))
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.getComplianceDate('tax'))))]), _vm._v(" "), _c('div', {
      staticClass: "progress-simple mt-1",
      class: _vm.getValidityStatus(_vm.getComplianceDate('tax'))
    })]), _vm._v(" "), _c('div', {
      staticClass: "compliance-row"
    }, [_c('span', [_vm._v("NP Authorization")]), _vm._v(" "), _c('span', {
      staticClass: "date mt-1",
      class: _vm.getDateColorClass(_vm.getComplianceDate('npAuthorization'))
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.getComplianceDate('npAuthorization'))))]), _vm._v(" "), _c('div', {
      staticClass: "progress-simple mt-1",
      class: _vm.getValidityStatus(_vm.getComplianceDate('npAuthorization'))
    })]), _vm._v(" "), _c('div', {
      staticClass: "compliance-row"
    }, [_c('span', [_vm._v("Permit validity")]), _vm._v(" "), _c('span', {
      staticClass: "date mt-1",
      class: _vm.getDateColorClass(_vm.getComplianceDate('permit'))
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.getComplianceDate('permit'))))]), _vm._v(" "), _c('div', {
      staticClass: "progress-simple mt-1",
      class: _vm.getValidityStatus(_vm.getComplianceDate('permit'))
    })]), _vm._v(" "), _c('div', {
      staticClass: "compliance-row"
    }, [_c('span', [_vm._v("Pollution Validity")]), _vm._v(" "), _c('span', {
      staticClass: "date mt-1",
      class: _vm.getDateColorClass(_vm.getComplianceDate('pollution'))
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.getComplianceDate('pollution'))))]), _vm._v(" "), _c('div', {
      staticClass: "progress-simple mt-1",
      class: _vm.getValidityStatus(_vm.getComplianceDate('pollution'))
    })])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row mt-4"
    }, [_c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "glass-card mb-4 p-4"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium"
    }, [_c('i', {
      staticClass: "fa fa-file-text-o mr-2"
    }), _vm._v(" Digital Archives")]), _vm._v(" "), _c('div', {
      staticClass: "doc-grid mt-3"
    }, _vm._l((_vm.vehicleDocs), function(doc) {
      return _c('div', {
        key: doc.key,
        staticClass: "doc-card",
        on: {
          "click": function($event) {
            _vm.downloadDoc(doc.file, doc.label)
          }
        }
      }, [_c('div', {
        staticClass: "doc-icon"
      }, [_c('i', {
        staticClass: "fa fa-file-pdf-o"
      })]), _vm._v(" "), _c('div', {
        staticClass: "doc-info"
      }, [_c('span', {
        staticClass: "doc-name"
      }, [_vm._v(_vm._s(doc.label))]), _vm._v(" "), _c('span', {
        staticClass: "doc-action text-primary"
      }, [_vm._v("View / Download")])])])
    }))])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'ulip') ? _c('div', {
      staticClass: "fade-in"
    }, [(!_vm.ulipData.ulip_vehicle_id) ? _c('div', {
      staticClass: "no-data-msg p-5 text-center"
    }, [_c('i', {
      staticClass: "fa fa-database fa-3x mb-3 opacity-25"
    }), _vm._v(" "), _c('h6', [_vm._v("No ULIP Record Found")]), _vm._v(" "), _c('p', {
      staticClass: "text-muted small"
    }, [_vm._v("ULIP API has not yet synchronized for this registration number.")])]) : _c('div', [(_vm.activeTab === 'ulip') ? _c('div', {
      staticClass: "fade-in"
    }, [(!_vm.ulipData.ulip_vehicle_id) ? _c('div', {
      staticClass: "no-data-msg p-5 text-center"
    }, [_c('i', {
      staticClass: "fa fa-database fa-3x mb-3 opacity-25"
    }), _vm._v(" "), _c('h6', [_vm._v("No ULIP Record Found")]), _vm._v(" "), _c('p', {
      staticClass: "text-muted small"
    }, [_vm._v("ULIP API has not yet synchronized for this registration number.")])]) : _c('div', [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-5"
    }, [_c('div', {
      staticClass: "stats-card owner-card mb-4 p-4 text-white shadow-lg h-100"
    }, [_c('div', {
      staticClass: "d-flex justify-content-between align-items-start"
    }, [_c('div', [_c('label', {
      staticClass: "text-white-50 text-xs font-weight-bold letter-spacing-1"
    }, [_vm._v("OWNER " + _vm._s((_vm.ulipData.rc_owner_sr || '1')))]), _vm._v(" "), _c('h5', {
      staticClass: "font-weight-bold mt-1 truncate-2"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_owner_name))]), _vm._v(" "), _c('p', {
      staticClass: "text-white-50 small mb-0"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_f_name ? 'S/O ' + _vm.ulipData.rc_f_name : ''))])]), _vm._v(" "), _c('b-badge', {
      staticClass: "px-3 py-1",
      attrs: {
        "pill": "",
        "variant": _vm.ulipData.rc_status === 'ACTIVE' ? 'success' : 'danger'
      }
    }, [_vm._v(_vm._s(_vm.ulipData.rc_status))])], 1), _vm._v(" "), _c('div', {
      staticClass: "row mt-4"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('label', {
      staticClass: "info-label text-white-50"
    }, [_vm._v("Regn No")]), _vm._v(" "), _c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_regn_no))])]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('label', {
      staticClass: "info-label text-white-50"
    }, [_vm._v("Regn Date")]), _vm._v(" "), _c('div', {
      staticClass: "font-weight-bold"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_regn_dt)))])])]), _vm._v(" "), _c('div', {
      staticClass: "row mt-3"
    }, [_c('div', {
      staticClass: "col-6"
    }, [_c('label', {
      staticClass: "info-label text-white-50"
    }, [_vm._v("Purchase Date")]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_purchase_dt)))])]), _vm._v(" "), _c('div', {
      staticClass: "col-6"
    }, [_c('label', {
      staticClass: "info-label text-white-50"
    }, [_vm._v("Regn Upto")]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_regn_upto)))])])]), _vm._v(" "), _c('div', {
      staticClass: "mt-4 pt-3 border-top border-white-10 d-flex justify-content-between align-items-center"
    }, [_c('span', {
      staticClass: "text-white-50 small"
    }, [_vm._v("ID: " + _vm._s(_vm.ulipData.ulip_vehicle_id))]), _vm._v(" "), (_vm.ulipData.rc_non_use === 'true') ? _c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v("Non-Use Reported")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-7"
    }, [_c('div', {
      staticClass: "glass-card mb-4 p-4 h-100"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium"
    }, [_c('i', {
      staticClass: "fa fa-truck mr-2"
    }), _vm._v(" Technical Specifications")]), _vm._v(" "), _c('div', {
      staticClass: "row mt-4"
    }, [_c('div', {
      staticClass: "col-sm-4 mb-3"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Maker / Model")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium small"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_maker_desc)), _c('br'), _vm._v(_vm._s(_vm.ulipData.rc_maker_model))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 mb-3"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Body / Class")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium small"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_body_type_desc)), _c('br'), _vm._v(_vm._s(_vm.ulipData.rc_vch_catg))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 mb-3"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Fuel / Norms")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium small"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_fuel_desc)), _c('br'), _vm._v(_vm._s(_vm.ulipData.rc_norms_desc))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 mb-3"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Weights (GVW/Unld)")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium small"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_gvw) + " / " + _vm._s(_vm.ulipData.rc_unld_wt) + " KG")])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 mb-3"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Capacity (S/S/W)")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium small"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_seat_cap) + "/" + _vm._s(_vm.ulipData.rc_sleeper_cap || 0) + "/" + _vm._s(_vm.ulipData.rc_wheelbase))])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 mb-3"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Engine / Cyl")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium small"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_cubic_cap) + " CC / " + _vm._s(_vm.ulipData.rc_no_cyl) + " Cyl")])]), _vm._v(" "), _c('div', {
      staticClass: "col-12 mt-2"
    }, [_c('div', {
      staticClass: "d-flex bg-light p-2 rounded justify-content-between"
    }, [_c('span', {
      staticClass: "small text-muted"
    }, [_vm._v("Chassis: " + _vm._s(_vm.ulipData.rc_chasi_no))]), _vm._v(" "), _c('span', {
      staticClass: "small text-muted"
    }, [_vm._v("Engine: " + _vm._s(_vm.ulipData.rc_eng_no))])])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row mt-2"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "glass-card mb-4 p-4"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium text-info"
    }, [_c('i', {
      staticClass: "fa fa-file-text mr-2"
    }), _vm._v(" Permit Intelligence")]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row mt-3"
    }, [_c('label', [_vm._v("Permit No")]), _vm._v(" "), _c('span', {
      staticClass: "small font-weight-bold"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_permit_no || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('span', {
      staticClass: "small truncate"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_permit_type || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("Valid From")]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_permit_valid_from)))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("Valid Upto")]), _vm._v(" "), _c('span', {
      staticClass: "small font-weight-bold text-success"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_permit_valid_upto)))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("Issued By")]), _vm._v(" "), _c('span', {
      staticClass: "small truncate"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_np_issued_by || 'N/A'))])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "glass-card mb-4 p-4"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium text-primary"
    }, [_c('i', {
      staticClass: "fa fa-shield mr-2"
    }), _vm._v(" Insurance Detail")]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row mt-3"
    }, [_c('label', [_vm._v("Company")]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_insurance_comp || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("Policy No")]), _vm._v(" "), _c('span', {
      staticClass: "small truncate text-monospace"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_insurance_policy_no || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("Valid Upto")]), _vm._v(" "), _c('span', {
      staticClass: "small font-weight-bold"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_insurance_upto)))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-4 pt-3 border-top"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium text-warning small"
    }, [_c('i', {
      staticClass: "fa fa-university mr-2"
    }), _vm._v(" Finance Info")]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row mt-2"
    }, [_c('label', [_vm._v("Financer")]), _vm._v(" "), _c('span', {
      staticClass: "small truncate"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_financer || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("Sale Amt")]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v("₹" + _vm._s(_vm.ulipData.rc_sale_amt || '0'))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "glass-card mb-4 p-4"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium text-success"
    }, [_c('i', {
      staticClass: "fa fa-check-circle mr-2"
    }), _vm._v(" Certificates")]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row mt-3"
    }, [_c('label', [_vm._v("Fitness Upto")]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_fit_upto)))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("Tax Upto")]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_tax_upto)))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("PUCC No")]), _vm._v(" "), _c('span', {
      staticClass: "small truncate"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_pucc_no || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "info-item-row"
    }, [_c('label', [_vm._v("PUCC Upto")]), _vm._v(" "), _c('span', {
      staticClass: "small"
    }, [_vm._v(_vm._s(_vm.formatDate(_vm.ulipData.rc_pucc_upto)))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-4 pt-3 border-top"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Color / Manufacturing")]), _vm._v(" "), _c('div', {
      staticClass: "info-value-premium small"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_color) + " | " + _vm._s(_vm.ulipData.rc_manu_month_yr))])])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticClass: "glass-card p-4"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium"
    }, [_c('i', {
      staticClass: "fa fa-map-marker mr-2"
    }), _vm._v(" Geolocation & Registry Intelligence")]), _vm._v(" "), _c('div', {
      staticClass: "row mt-3"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Registry Point")]), _vm._v(" "), _c('div', {
      staticClass: "small font-weight-bold text-dark"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_registered_at))]), _vm._v(" "), _c('div', {
      staticClass: "text-xs text-muted"
    }, [_vm._v(_vm._s(_vm.ulipData.state_cd) + " - " + _vm._s(_vm.ulipData.rto_cd))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Present Address")]), _vm._v(" "), _c('div', {
      staticClass: "small opacity-75"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_present_address || 'N/A'))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5"
    }, [_c('label', {
      staticClass: "info-label"
    }, [_vm._v("Permanent Address")]), _vm._v(" "), _c('div', {
      staticClass: "small opacity-75"
    }, [_vm._v(_vm._s(_vm.ulipData.rc_permanent_address || 'N/A'))])])])])])])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'fasttag') ? _c('div', {
      staticClass: "fade-in h-100"
    }, [(!_vm.fasttagData.length) ? _c('div', {
      staticClass: "no-data-msg p-5 text-center"
    }, [_c('i', {
      staticClass: "fa fa-rss fa-3x mb-3 opacity-25"
    }), _vm._v(" "), _c('h6', [_vm._v("No Fasttag Activity")]), _vm._v(" "), _c('p', {
      staticClass: "text-muted small"
    }, [_vm._v("We haven't detected any toll crossings for this vehicle in the current billing cycle.")])]) : _c('div', {
      staticClass: "h-100 flex-column d-flex"
    }, [_c('div', {
      staticClass: "table-responsive-container flex-grow-1"
    }, [_c('table', {
      staticClass: "table premium-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Toll Plaza")]), _vm._v(" "), _c('th', [_vm._v("Direction")]), _vm._v(" "), _c('th', [_vm._v("Transaction Time")]), _vm._v(" "), _c('th', [_vm._v("Sequence No")]), _vm._v(" "), _c('th', [_vm._v("Type")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.fasttagData), function(log, idx) {
      return _c('tr', {
        key: idx
      }, [_c('td', {
        staticClass: "font-weight-bold text-dark"
      }, [_vm._v(_vm._s(log.uf_toll_plaza_name))]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "direction-badge",
        class: log.uf_lane_direction
      }, [_c('i', {
        staticClass: "fa",
        class: log.uf_lane_direction === 'O' ? 'fa-arrow-left' : 'fa-arrow-right'
      }), _vm._v("\n                                          " + _vm._s(log.uf_lane_direction === 'O' ? 'Outbound' : 'Inbound') + "\n                                      ")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDateTime(log.uf_reader_read_time)))]), _vm._v(" "), _c('td', {
        staticClass: "text-muted font-weight-normal"
      }, [_vm._v(_vm._s(log.uf_seq_no))]), _vm._v(" "), _c('td', [_c('b-badge', {
        attrs: {
          "pill": "",
          "variant": "light"
        }
      }, [_vm._v(_vm._s(log.uf_vehicle_type))])], 1)])
    }))])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'challan') ? _c('div', {
      staticClass: "fade-in h-100"
    }, [(!_vm.challans.length) ? _c('div', {
      staticClass: "no-data-msg p-5 text-center"
    }, [_c('i', {
      staticClass: "fa fa-gavel fa-3x mb-3 opacity-25"
    }), _vm._v(" "), _c('h6', [_vm._v("Clean Legal History")]), _vm._v(" "), _c('p', {
      staticClass: "text-muted small"
    }, [_vm._v("No active or historical challans found on record for this registration.")])]) : _c('div', {
      staticClass: "h-100 flex-column d-flex"
    }, [_c('div', {
      staticClass: "table-responsive-container flex-grow-1"
    }, [_c('table', {
      staticClass: "table premium-table"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Challan details")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Fine Amount")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Offences")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.challans), function(challan, idx) {
      return _c('tr', {
        key: idx
      }, [_c('td', [_c('div', {
        staticClass: "d-flex flex-column"
      }, [_c('span', {
        staticClass: "font-weight-bold"
      }, [_vm._v(_vm._s(challan.challan_no))]), _vm._v(" "), _c('span', {
        staticClass: "text-xs text-muted"
      }, [_vm._v(_vm._s(_vm.formatDateTime(challan.challan_date_time)))])])]), _vm._v(" "), _c('td', [_c('b-badge', {
        staticClass: "text-xs px-3 py-1",
        attrs: {
          "variant": challan.challan_status === 'Pending' ? 'danger' : 'success'
        }
      }, [_vm._v("\n                                          " + _vm._s(challan.challan_status) + "\n                                      ")])], 1), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "d-flex flex-column"
      }, [_c('span', {
        staticClass: "font-weight-bold"
      }, [_vm._v("₹" + _vm._s(challan.received_amount || 0))]), _vm._v(" "), (challan.fine_imposed) ? _c('span', {
        staticClass: "text-xs text-info"
      }, [_vm._v("Imposed: ₹" + _vm._s(challan.fine_imposed))]) : _vm._e()])]), _vm._v(" "), _c('td', [_c('div', {
        staticClass: "max-w-200"
      }, [_c('span', {
        directives: [{
          name: "b-tooltip",
          rawName: "v-b-tooltip.hover",
          modifiers: {
            "hover": true
          }
        }],
        staticClass: "small d-block text-truncate",
        attrs: {
          "title": challan.challan_place
        }
      }, [_vm._v("\n                                              " + _vm._s(challan.challan_place) + "\n                                          ")])])]), _vm._v(" "), _c('td', {
        staticClass: "max-w-300"
      }, [_c('div', {
        staticClass: "offence-tags"
      }, _vm._l((challan.offence_details), function(off, oidx) {
        return _c('span', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover",
            modifiers: {
              "hover": true
            }
          }],
          key: oidx,
          staticClass: "offence-chip",
          attrs: {
            "title": off.act
          }
        }, [_vm._v("\n                                              " + _vm._s(off.name) + "\n                                          ")])
      }))])])
    }))])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'maintenance') ? _c('div', {
      staticClass: "fade-in h-100"
    }, [(_vm.maintenanceLoading) ? _c('div', {
      staticClass: "no-data-msg p-5 text-center"
    }, [_c('b-spinner', {
      staticClass: "mb-3",
      attrs: {
        "variant": "primary"
      }
    }), _vm._v(" "), _c('h6', [_vm._v("Loading Maintenance Details...")])], 1) : _c('div', {
      staticClass: "h-100 flex-column d-flex"
    }, [(_vm.maintenanceItemBrief.length) ? _c('div', {
      staticClass: "glass-card mb-4 p-4"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium text-primary"
    }, [_c('i', {
      staticClass: "fa fa-wrench mr-2"
    }), _vm._v(" Maintenance Item Brief")]), _vm._v(" "), _c('div', {
      staticClass: "table-responsive-container"
    }, [_c('table', {
      staticClass: "table premium-table mb-0"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Total Qty")]), _vm._v(" "), _c('th', [_vm._v("Rate Range")]), _vm._v(" "), _c('th', [_vm._v("Total Spend")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.maintenanceItemBrief), function(item, idx) {
      return _c('tr', {
        key: 'brief-' + idx
      }, [_c('td', {
        staticClass: "font-weight-bold text-dark"
      }, [_vm._v(_vm._s(item.itemName || "N/A"))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Number(item.totalQuantity || 0).toLocaleString("en-IN")))]), _vm._v(" "), _c('td', [_vm._v("₹" + _vm._s(Number(item.minRate || 0).toLocaleString("en-IN")) + " - ₹" + _vm._s(Number(item.maxRate || 0).toLocaleString("en-IN")))]), _vm._v(" "), _c('td', {
        staticClass: "font-weight-bold"
      }, [_vm._v("₹" + _vm._s(Number(item.totalSpend || 0).toLocaleString("en-IN")))])])
    }))])])]) : _vm._e(), _vm._v(" "), (!_vm.maintenanceHistory.length) ? _c('div', {
      staticClass: "no-data-msg p-5 text-center"
    }, [_c('i', {
      staticClass: "fa fa-history fa-3x mb-3 opacity-25"
    }), _vm._v(" "), _c('h6', [_vm._v("No Maintenance Records Found")]), _vm._v(" "), _c('p', {
      staticClass: "text-muted small"
    }, [_vm._v("No maintenance tickets are available for this vehicle.")])]) : _c('div', {
      staticClass: "glass-card p-4"
    }, [_c('h6', {
      staticClass: "card-subtitle-premium text-info"
    }, [_c('i', {
      staticClass: "fa fa-list-alt mr-2"
    }), _vm._v(" Maintenance History")]), _vm._v(" "), _c('div', {
      staticClass: "table-responsive-container"
    }, [_c('table', {
      staticClass: "table premium-table mb-0"
    }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Ticket")]), _vm._v(" "), _c('th', [_vm._v("Service Date")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Est. Cost")]), _vm._v(" "), _c('th', [_vm._v("Items")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.maintenanceHistory), function(row, idx) {
      return _c('tr', {
        key: 'maint-' + idx
      }, [_c('td', {
        staticClass: "font-weight-bold"
      }, [_vm._v(_vm._s(row.ticketId || row.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(row.serviceDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.serviceType || "N/A"))]), _vm._v(" "), _c('td', [_c('b-badge', {
        attrs: {
          "pill": "",
          "variant": String(row.status || '').toLowerCase().includes('approve') ? 'success' : 'warning'
        }
      }, [_vm._v("\n                                            " + _vm._s(row.status || "Pending") + "\n                                        ")])], 1), _vm._v(" "), _c('td', {
        staticClass: "font-weight-bold"
      }, [_vm._v("₹" + _vm._s(Number(row.estimatedCost || 0).toLocaleString("en-IN")))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Array.isArray(row.items) ? row.items.length : 0))])])
    }))])])])])]) : _vm._e()])])
  ], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64338174","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/VehicleMasterDetailsModal.vue
// module id = 2688
// module chunks = 0